import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import BaseGrid from 'components/atoms/base-grid';
import BaseDownloadButton from 'components/atoms/download-button';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import withLoader from 'components/organisms/withLoader';
import ExpandablePatientEngagementReportFilters from 'components/templates/rpm/practice/patientEngagementStatusReport/expandable-filters';
import EngagementAttemptsOverviewPieChart from 'components/templates/rpm/practice/patientEngagementStatusReport/charts/engagement-attempts-overview-pie-chart';
import StatusOverviewPieChart from 'components/templates/rpm/practice/patientEngagementStatusReport/charts/status-overview-pie-chart';
import AttemptSuccessTrackingTiles from 'components/templates/rpm/practice/patientEngagementStatusReport/tiles';
import PatientEngagementReportTable from 'components/templates/rpm/practice/patientEngagementStatusReport/table';
import {
  useDownloadPatientEngagementReport,
  usePatientEngagementReportFilter,
} from 'infrastructure/hooks/patient-engagement-report';

import s from './styles.module.scss';

interface IPatientEngagementStatusReportProps {}

const PatientEngagementStatusReport: FC<
  IPatientEngagementStatusReportProps
> = () => {
  const { t } = useTranslation();
  const { count, filter, resetFilter, updateFilter } =
    usePatientEngagementReportFilter();
  const { download, isLoading: isDownloading } =
    useDownloadPatientEngagementReport();

  return (
    <>
      <div className={s.header}>
        <h1 className={s.pageTitle}>
          {t('links.patientEngagementStatusReport')}
        </h1>
        {withLoader(
          isDownloading,
          <BaseDownloadButton
            onClick={() => download(filter)}
            disabled={isDownloading}
          />,
        )}
      </div>
      <BaseGrid rowGap={20}>
        <div className={s.charts}>
          <StatusOverviewPieChart filter={filter} />
          <EngagementAttemptsOverviewPieChart filter={filter} />
        </div>
        <ExpandablePatientEngagementReportFilters
          filter={filter}
          count={count}
          updateFilter={updateFilter}
          resetFilter={resetFilter}
        />
        <PatientEngagementReportTable
          filter={filter}
          updateFilter={updateFilter}
        />
        <AttemptSuccessTrackingTiles
          filter={filter}
          updateFilter={updateFilter}
        />
      </BaseGrid>
      <ScrollToTopButton />
    </>
  );
};

export default PatientEngagementStatusReport;
